import * as React from "react";

// https://chatgpt.com/c/697b624b-3d34-832d-9b52-fea0f9910b88
export function useMediaQuery(query: string) {
  const [matches, setMatches] = React.useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  );

  React.useEffect(() => {
    const media = window.matchMedia(query);

    // Set initial value
    setMatches(media.matches);

    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);

    // Modern + Safari fallback
    media.addEventListener?.("change", listener);
    media.addListener?.(listener);

    return () => {
      media.removeEventListener?.("change", listener);
      media.removeListener?.(listener);
    };
  }, [query]);

  return matches;
}
